import { render, staticRenderFns } from "./FormStateLocale.vue?vue&type=template&id=183a51e8&scoped=true&"
import script from "./FormStateLocale.vue?vue&type=script&lang=js&"
export * from "./FormStateLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a51e8",
  null
  
)

export default component.exports